import {useTranslation} from '@aboutyou/i18n';
import {useOpenedStateManager} from '@aboutyou/opened-state-manager';
import {useQueryParams} from '@aboutyou/router';
import React, {useEffect, useRef} from 'react';
import {useAuthenticationPrompt} from '../../../features/Authentication/AuthenticationProvider/AuthenticationProvider';
import {useIsAuthenticated} from '../../../features/Authentication/hooks/useIsAuthenticated';
import {useIsCouponsEnabled} from '../../../features/Coupons/useIsCouponsEnabled';
import {CouponLoginHeaderBanner} from './CouponLoginBanner';

export const ACTIVATION_COUPON_STATE_KEY = 'BasketCouponActivationFlyout';
export const COUPON_LOGIN_QUERY_PARAM = 'couponToApply';

export const BasketPageCouponLoginChecker = ({
  withAboveHeader,
}: {
  withAboveHeader?: boolean;
}) => {
  const queryParams = useQueryParams();
  const hasCoupon = !!queryParams.get(COUPON_LOGIN_QUERY_PARAM);
  const {showUserAuthenticationPrompt} = useAuthenticationPrompt();
  const isLoggedIn = useIsAuthenticated();
  const isCouponActive = useIsCouponsEnabled();
  const {t} = useTranslation();
  const {open} = useOpenedStateManager(ACTIVATION_COUPON_STATE_KEY);
  const wasOpened = useRef(false);

  const onSuccess = () => {
    open();
  };
  const onError = () => {};
  const onCancel = () => {};

  // eslint-disable-next-line local-rules/too-complex-useeffects
  useEffect(() => {
    if (hasCoupon && isCouponActive && !wasOpened.current) {
      if (!isLoggedIn.isAuthenticated && !isLoggedIn.isUserDataLoading) {
        showUserAuthenticationPrompt({
          needsCheckoutSession: false,
          disableSuccessToast: true,
          ...(!withAboveHeader
            ? {
                // used on mweb
                customBannerComponent: (
                  <CouponLoginHeaderBanner
                    textContent={t('Login to activate Coupons')}
                  />
                ),
              }
            : {
                // // used on desktop
                aboveHeaderBannerComponent: (
                  <CouponLoginHeaderBanner
                    textContent={t(
                      'Log in to activate your exclusive Coupon Discounts!',
                    )}
                  />
                ),
              }),
          onSuccess,
          onError,
          onCancel,
        });
        wasOpened.current = true;
      } else {
        if (isLoggedIn.isAuthenticated) {
          open();
          wasOpened.current = true;
        }
      }
    }
  }, [isLoggedIn]);

  return null;
};
